import React from 'react';
import PropTypes from 'prop-types';

import Avatar from 'components/Avatar';

import ChatRoomButton from './ChatRoomButton';
import Header from './Header';
import Username from './Username';
import LastMessageTime from './LastMessageTime';
import Body from './Body';
import LastMessage from './LastMessage';
import UnreadLabel from './UnreadLabel';

export class ChatRoom extends React.PureComponent {
  handleClick = () => {
    this.props.onSelect(this.props.id);
  }

  render() {
    return (
      <ChatRoomButton
        type="button"
        onClick={this.handleClick}
        active={this.props.active}
        isOpen={this.props.isChatRoomOpen}
      >
        <div style={{ paddingRight: '16px' }}>
          <Avatar
            size="40px"
            name={this.props.username}
            url={this.props.avatarUrl}
            hasBorder
          />
        </div>

        <div style={{ width: 'calc(100% - 40px - 16px)' }}>
          <Header>
            <Username>{this.props.username}</Username>

            <LastMessageTime>{new Date(this.props.lastMessageAt).toLocaleString('ru')}</LastMessageTime>
          </Header>

          <Body>
            <LastMessage unread={this.props.hasNewMessages}>
              {this.props.lastMessage}
            </LastMessage>

            {this.props.hasNewMessages && (
              <UnreadLabel style={{ transform: `translateX(${this.props.isChatRoomOpen ? '-289px' : '0'})` }} />
            )}
          </Body>
        </div>
      </ChatRoomButton>
    );
  }
}

ChatRoom.propTypes = {
  id: PropTypes.string,
  username: PropTypes.string,
  avatarUrl: PropTypes.string,
  lastMessage: PropTypes.string,
  lastMessageAt: PropTypes.number,
  hasNewMessages: PropTypes.bool,

  active: PropTypes.bool,
  isChatRoomOpen: PropTypes.bool,

  onSelect: PropTypes.func,
};

ChatRoom.defaultProps = {
  id: '',
  username: '',
  avatarUrl: '',
  lastMessage: '',
  lastMessageAt: 0,
  hasNewMessages: false,

  active: false,
  isChatRoomOpen: false,

  onSelect: () => {},
};

export default ChatRoom;
